<template>
  <div class="history" :class="{ 'animate-flicker': loading }">
    <div class="nav-top">
      <div class="back" @click="$router.go(-1)">
        <back />
      </div>
      <div class="title">TUGAS {{ $route.query.nama }}</div>
    </div>

    <div class="body">
      <div class="task">
        <ul>
          <li
            v-for="(item, index) in data"
            :key="index"
            :class="
              item.status == 'COMPLETE'
                ? 'complete'
                : item.diff < 0 && item.status != 'COMPLETE'
                ? 'danger'
                : item.diff <= 3 && item.status != 'COMPLETE'
                ? 'warning'
                : ''
            "
            @click="to('/detail/' + item.id + '?editable=true')"
          >
            <div>
              <div v-if="$user.access == 'ADMIN'">
                <small>{{ item.user }}</small>
              </div>
              <p>{{ item.nama }}</p>
              <small>
                {{
                  item.diff > 0
                    ? Math.abs(item.diff) + " hari lagi"
                    : "Target selesai pada tanggal " + (moment(item.tgl_target).format('DD/MM/YY'))
                }}
              </small>
            </div>
            <div>
              <right />
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import * as api from "../api/Api";

import Back from "./icons/Back.vue";
import Right from "./icons/Right.vue";

export default {
  name: "Home",
  components: {
    Back,
    Right,
  },
  data() {
    return {
      loading: false,
      data: [],
    };
  },
  methods: {
    moment,
    to(to) {
      setTimeout(() => {
        this.$router.push(to);
      }, 150);
    },
    loadData() {
      api
        .get(
          "/v1/kendali_kerja/pekerjaanController/get?id_user=" +
            this.$route.params.id
        )
        .then((r) => {
          this.data = r.data;
        });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped lang="scss">
.history {
  background: #f2f3f7;
  min-height: 100vh;
  padding-bottom: 60px;
  .nav-top {
    background: #fff;
    box-shadow: 0px 2px 3px #ccc;
    display: grid;
    grid-template-columns: 50px 1fr;
    margin-bottom: 2px;

    .back {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .title {
      font-size: 14px;
      font-weight: bold;
      padding: 15px;
    }
    .save {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #009be7;
      color: #fff;
      &:active {
        background: #0087ca;
      }
    }
  }

  .body {
    .task {
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HistoryUser.vue